<template>
  <div class="div-layout tab-resetStyle">
    <el-tabs ref="tabs" v-model="activeName" @tab-click="handleLoad">
      <el-tab-pane v-for="item of filterMainList" :key="item.key" :label="item.label" :name="item.key">
        <component
          :is="item.componentName"
          v-if="activeName===item.key"
          :key="item.key"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RentBook from './rentBook';// 租书记录
import BookList from './bookList';// 图书列表
import BookType from './bookType';// 图书分类
import FreeBooks from './freeBooks';// 免费图书
import EnglishBooks from './englishBooks';
import SafeBooks from './safeBooks';
import OtherBooks from './otherBooks';
import Draw from './draw';
import WarnList from './warnList';// 预警监控
export default {
  name: 'EllaRentBooks',
  components: {
    RentBook,
    BookList,
    BookType,
    FreeBooks,
    EnglishBooks,
    SafeBooks,
    OtherBooks,
    WarnList,
    Draw
  },
  computed: {
    activeName: {// tab选中
      get() {
        return this.$store.state.ella.activeNameElla;
      },
      set(value) {
        this.$store.commit('SET_ELLAACTIVENAME', value);
      }
    },
    filterMainList() {
      return [{
        componentName: 'RentBook',
        key: 'first',
        label: '租书记录'
      }, {
        componentName: 'BookList',
        key: 'two',
        label: '图书列表'
      },
      {
        componentName: 'BookType',
        key: 'three',
        label: '图书分类'
      }, {
        componentName: 'FreeBooks',
        key: 'four',
        label: '限免专区'
      }, {
        componentName: 'SafeBooks',
        key: 'five',
        label: '安全教育'
      }, {
        componentName: 'EnglishBooks',
        key: 'six',
        label: '品格素养'
      }, {
        componentName: 'OtherBooks',
        key: 'seven',
        label: '有声识字'
      },
      {
        componentName: 'Draw',
        key: 'nine',
        label: '绘画天地'
      },
      {
        componentName: 'WarnList',
        key: 'eight',
        label: '预警监控'
      }];
    }
  },
  mounted() {
    this.$store.dispatch('fetchAppBooKtypesTree');
  },
  methods: {
    handleLoad(data) {
      this.activeName = data.name;
    }
  }
};
</script>
